var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { createContext, useContext, useState } from 'react';
import { SceneStates } from '../../datas/constants';
var AppStateContext = createContext(undefined);
export var AppStateProvider = function (_a) {
    var children = _a.children;
    var _b = useState(SceneStates.LOADER), sceneState = _b[0], setSceneState = _b[1];
    var _c = useState(false), isScene = _c[0], setIsScene = _c[1];
    var _d = useState(""), productName = _d[0], setProductName = _d[1];
    var _e = useState(""), productNameMulti = _e[0], setProductNameMulti = _e[1];
    var _f = useState(""), hoveredProductName = _f[0], setHoveredProductName = _f[1];
    var _g = useState({
        XPosition: 0,
        YPosition: 0,
        screenX: 0,
        screenY: 0,
    }), labelPosition = _g[0], setLabelPosition = _g[1];
    var _h = useState(false), videoLoader = _h[0], setVideoLoader = _h[1];
    var _j = useState(true), withSound = _j[0], setWithSound = _j[1];
    var _k = useState({}), sceneTutorialShown = _k[0], setSceneTutorialShown = _k[1];
    var _l = useState(false), isPopupOpen = _l[0], setIsPopupOpen = _l[1];
    var resetProductName = function () { return setProductName(""); };
    var resetProductNameMulti = function () { return setProductNameMulti(""); };
    var markTutorialShown = function (sceneName) {
        setSceneTutorialShown(function (prev) {
            var _a;
            return (__assign(__assign({}, prev), (_a = {}, _a[sceneName] = true, _a)));
        });
    };
    var resetTutorialShown = function () {
        setSceneTutorialShown({});
    };
    return (_jsx(AppStateContext.Provider, __assign({ value: {
            sceneState: sceneState,
            setSceneState: setSceneState,
            isScene: isScene,
            setIsScene: setIsScene,
            productName: productName,
            setProductName: setProductName,
            resetProductName: resetProductName,
            productNameMulti: productNameMulti,
            setProductNameMulti: setProductNameMulti,
            resetProductNameMulti: resetProductNameMulti,
            hoveredProductName: hoveredProductName,
            setHoveredProductName: setHoveredProductName,
            labelPosition: labelPosition,
            setLabelPosition: setLabelPosition,
            videoLoader: videoLoader,
            setVideoLoader: setVideoLoader,
            withSound: withSound,
            setWithSound: setWithSound,
            sceneTutorialShown: sceneTutorialShown,
            setSceneTutorialShown: setSceneTutorialShown,
            markTutorialShown: markTutorialShown,
            resetTutorialShown: resetTutorialShown,
            isPopupOpen: isPopupOpen,
            setIsPopupOpen: setIsPopupOpen
        } }, { children: children })));
};
export var useAppState = function () {
    var context = useContext(AppStateContext);
    if (!context) {
        throw new Error("useAppState must be used within an AppStateProvider");
    }
    return context;
};
